module.exports = __webpack_public_path__ + "assets/webgl/LM_1_1.jpg.5e021ada.webp";